module.exports = __webpack_public_path__ + "img/13.be6231c7.png";